import { Box, Button, Container } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { HeaderWithActions } from '@planning/components'
import { carrierVisitService } from '@planning/services'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router'
import { ViewToggleButtons } from '../VesselVisit/Components/atoms/ViewToggleButtons'
import { RailVisitPlanning } from './Components/Planning/RailVisitPlanning'
import { RailVisitTable } from './Components/Table/RailVisitTable'
import { RailVisitPlanningViewStore } from './stores/RailVisitPlanningViewStore'

export const RailVisitPage = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const navigate = useNavigate()

  const {
    railVisitListViewStore,
    railVisitItemStore,
    railTrackItemStore,
    railcarTrackPositionItemStore,
  } = usePlanningStore()

  const railVisitPlanningViewStore = useMemo(
    () =>
      new RailVisitPlanningViewStore(
        railTrackItemStore,
        railVisitItemStore,
        railcarTrackPositionItemStore,
      ),
    [railTrackItemStore, railVisitItemStore, railcarTrackPositionItemStore],
  )

  useEffect(() => {
    railVisitListViewStore.setDateRange(
      moment().add(-10, 'd').startOf('d').toDate(),
      moment().add(10, 'd').endOf('d').toDate(),
    )

    railVisitListViewStore.loadCurrentPage()
  }, [railVisitListViewStore])

  const handleCreateRailVisit = () => {
    navigate(PATHS.visits.railPlanning.url)
  }

  const handleDelete = async (id: number) => {
    await carrierVisitService.delete(id)
  }

  const items = railVisitListViewStore.pageItems || []

  const [viewListMode, setViewListMode] = useState(true)

  const toggleActionBtn = (
    <ViewToggleButtons
      carrierType='Train'
      currentView={viewListMode ? 'list' : 'plan'}
      onListClick={() => setViewListMode(true)}
      onPlanClick={() => setViewListMode(false)}
    />
  )

  return (
    <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100vh' }}>
      <Helmet>
        <title>{t('railVisits', 'Rail Visits')}</title>
      </Helmet>

      <HeaderWithActions
        title={t('railVisits', 'Rail Visits')}
        noMarginBottom
        actions={[
          <Button
            key='create'
            variant='contained'
            data-cy='create-rail-visit-btn'
            onClick={handleCreateRailVisit}
          >
            {t('createVisit', 'Create visit')}
          </Button>,
        ]}
      />

      <Container sx={{ paddingY: 2, maxWidth: '100% !important' }}>
        {viewListMode ? (
          <RailVisitTable
            items={items}
            onDelete={handleDelete}
            renderTableCustomActions={() => (
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                {toggleActionBtn}
              </Box>
            )}
          />
        ) : (
          <RailVisitPlanning store={railVisitPlanningViewStore} headerActions={toggleActionBtn} />
        )}
      </Container>
    </Box>
  )
})
